<div
  *transloco="let t; read: 'widgets.change-widget-group-dialog'"
  class="xi-modal__container change-dfg__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ headerText }}</h2>

  <form [formGroup]="changeDFGForm">
    <div class="xi-modal__content change-dfg__content">
      <div class="change-dfg__dropdown">
        <xi-dropdown
          formControlName="filterGroup"
          label="{{ descriptionText }}"
          [placeholder]="t('select-widget-group')"
          name="filterGroup"
          [stretch]="true"
          [data]="widgetGroups"
        ></xi-dropdown>
      </div>
    </div>

    <div class="xi-modal__actions">
      <xi-default-button
        type="button"
        [text]="t('cancel')"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>

      <xi-default-button
        [text]="t('save')"
        (onClick)="onSave()"
        [disabled]="changeDFGForm.invalid"
      ></xi-default-button>
    </div>
  </form>
</div>
